import advancedAutomation from "../../api/advancedAutomation";
import moment from "moment";
import { perPageCount } from "@/common/constants";
import {
  dummyRows,
  formatDate,
  StatusIcon,
  convertCount,
  capitalizeFirstLetter,
} from "@/common/functions";

const getDefaultState = () => {
  return {
    items: [],
    loaded: false,
    filter: {
      page: 1,
      per_page_count: perPageCount,
      camp_name: "",
      date_from: "",
      date_to: "",
      senderId: "",
      status: "",
      sort_field: "modifiedDate",
      sort_order: "desc",
      add_sort: 0,
    },
    totalItems: 0,
    total: 0,
    showFilter: false,
    busyLoaderStatus: true,
    automationAnalyticalData: {
      entrolled: [],
      active: [],
      skipped: [],
      completed: [],
    },
    automationCount: 0,
    ReportAnalyticsLoaded: true,
  };
};

// initial state
const state = getDefaultState();
// getters
const getters = {
  getEnrolledItems: (state) => {
    let items = state.automationAnalyticalData["entrolled"]
      ? state.automationAnalyticalData["entrolled"]
      : [];
    if (!items.length) {
      return dummyRows();
    }
    return items;
  },
  getItems: (state) => {
    if (!state.items.length && !state.loaded) {
      return dummyRows();
    }
    var tempItem = [];
    for (var i = 0; i < state.items.length; i++) {
      var status = state.items[i].status.toLowerCase();
      var modifiedDate = moment(state.items[i].modified_date).format(
        "DD MMM YYYY"
      );
      var modifiedTime = moment(state.items[i].modified_date).format("h:mm A");
      var createdDate = moment(state.items[i].created_date).format(
        "DD MMM YYYY h:mm A"
      );
      tempItem.push({
        id: state.items[i].id,
        name: {
          title: state.items[i].name,
          text: "Created at " + createdDate,
        },
        modified_date: modifiedDate,
        modifiedTime: modifiedTime,
        status: {
          text: capitalizeFirstLetter(status),
          type: StatusIcon(capitalizeFirstLetter(status)),
        },
        enrolled_count: state.items[i].enrolled_count || 0,
        finished_count: convertCount(
          state.items[i].finished_count ? state.items[i].finished_count : 0
        ),
        skipped_count: convertCount(
          state.items[i].skipped_count ? state.items[i].skipped_count : 0
        ),
      });
    }
    return tempItem;
  },
};

// actions
const actions = {
  getAutomationAnalyticalData({ commit }, params) {
    commit("setReportAnalyticsLoaded", false);
    commit("setAutomationAnalyticalData", { type: params.type, data: [] });
    if (params.type == "entrolled" || params.type == "active") {
      advancedAutomation
        .getAutomationAnalyticalData(params.id, params.type, params.params)
        .then((response) => {
          if (response) {
            commit("setAutomationAnalyticalData", {
              type: params.type,
              data: response,
            });
          }
        })
        .finally(() => {
          commit("setReportAnalyticsLoaded", true);
        });
    } else {
      // params.status = type;
      advancedAutomation
        .getAutomationActivitiesData(params.id, {
          status: params.type,
          page: params.params.page,
          limit: params.params.limit,
        })
        .then((response) => {
          if (response && response.data) {
            commit("setAutomationAnalyticalData", {
              type: "entrolled",
              data: response.data,
            });
          }
        })
        .finally(() => {
          commit("setReportAnalyticsLoaded", true);
        });
    }
  },
  fetchItems({ commit, state }, params) {
    var filter = state.filter;
    if (
      !state.loaded ||
      filter.page !== params.page ||
      filter.per_page_count !== params.per_page_count ||
      filter.camp_name !== params.camp_name ||
      filter.date_from !== params.date_from ||
      filter.date_to !== params.date_to ||
      filter.status !== params.status ||
      filter.sort_field !== params.sort_field ||
      filter.sort_order !== params.sort_order
    ) {
      commit("setFilter", { ...params });
      var post = {
        limit: params.per_page_count ? params.per_page_count : 10,
        page: params.page ? params.page : 1,
        search: params.camp_name ? params.camp_name : "",
        //"sort_field":  params.sort_field ? params.sort_field : "",
        //"sort_order": params.sort_order ? params.sort_order : "",
        date_from: params.date_from ? params.date_from : "",
        date_to: params.date_to ? params.date_to : "",
        status: params.status ? params.status : "",
      };
      const sortAllowed = [
        "name",
        "created_date",
        "enrolled_count",
        "finished_count",
        "skipped_count",
        "modified_date",
      ];
      if (
        params.sort_field &&
        params.sort_field !== "" &&
        sortAllowed.includes(params.sort_field)
      ) {
        post.sort_field = params.sort_field;
        post.sort_order = params.sort_order;
      }

      return new Promise(function (resolve, reject) {
        advancedAutomation.fetchReportItems(post, (data) => {
          if (data.message) {
            reject(data.message);
          }
          commit("setItems", { items: data.items });
          commit("setTotalItems", data.total);
          commit("setAutomationCount", data.automationCount);
          commit("setLoaded", true);
          commit("setBusyLoaderStatus", true);
          resolve(data.total);
        });
      });
    }
  },
};

// mutations
const mutations = {
  setAutomationCount(state, count) {
    state.automationCount = count;
  },
  setReportAnalyticsLoaded(state, status) {
    state.ReportAnalyticsLoaded = status;
  },
  setItems(state, { items }) {
    state.items = items;
  },
  setFilter(state, data) {
    state.filter = data;
  },
  setTotalItems(state, total) {
    state.totalItems = total;
  },
  setShowFilter(state, status) {
    state.showFilter = status;
  },
  setTotal(state, total) {
    state.total = total;
  },
  setLoaded(state, loaded) {
    state.loaded = loaded;
  },
  setBusyLoaderStatus(state, status) {
    state.busyLoaderStatus = status;
  },
  setAutomationAnalyticalData(state, { type, data }) {
    state.automationAnalyticalData[type] = [];
    data.forEach((data) => {
      var time = formatDate(data.time_logged, "MMM DD, YYYY h:mm A");
      if (type == "entrolled") {
        state.automationAnalyticalData[type].push({
          contact: data.email,
          status: data.status,
          time: time,
        });
      } else {
        state.automationAnalyticalData[type].push({
          contact: data.email,
          time: time,
          status: data.actionData.actionMessage,
          // actionObj: `"` + data.actionData.actionValue + `"`,
        });
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
